import { render, staticRenderFns } from "./TagCollector.vue?vue&type=template&id=6e2aa396&scoped=true"
import script from "./TagCollector.vue?vue&type=script&lang=js"
export * from "./TagCollector.vue?vue&type=script&lang=js"
import style0 from "./TagCollector.vue?vue&type=style&index=0&id=6e2aa396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2aa396",
  null
  
)

export default component.exports